export default "__VITE_ASSET__Rc1pkj2O__"